import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  source: null,
  activeIndex: null,
  suppressHighlight: false
};

export const SideBarSlice = createSlice({
  name: "sidebarItem",
  initialState,
  reducers: {
    show: (state, action) => {
      state.visible = true;
      state.source = action.payload;
      state.activeIndex = null;
      state.suppressHighlight = true;
    },
    hide: (state, action) => {
      state.visible = false;
      state.source = null;
      state.activeIndex = null;
    },
    setActiveIndex: (state, action) => {
      state.activeIndex = action.payload;
      if (action.payload !== null) {
        state.suppressHighlight = false;
      }
    }
  },
});

// Action creators are generated for each case reducer function
export const { show, hide, setActiveIndex } = SideBarSlice.actions;

export default SideBarSlice.reducer;
